export default __webpack_public_path__ + "static/media/telegram.d42bba1c.svg";